var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Titles')))]), _c('v-divider'), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "tile": "",
      "group": "",
      "color": "primary"
    },
    model: {
      value: _vm.sort,
      callback: function callback($$v) {
        _vm.sort = $$v;
      },
      expression: "sort"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "value": "rare"
    }
  }, [_vm._v(_vm._s(_vm.$t('Number of ★5')))]), _c('v-btn', {
    attrs: {
      "small": "",
      "value": "characters"
    }
  }, [_vm._v(_vm._s(_vm.$t('Number of Characters')))])], 1)], 1), _vm._l(_vm.titleList, function (title) {
    return [_c('v-divider'), _c('v-list-item', {
      attrs: {
        "to": "/title/".concat(title.m_TitleType)
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "mx-auto mr-2 mr-md-4",
      attrs: {
        "width": _vm.$size() * 4,
        "height": _vm.$size(),
        "tile": ""
      }
    }, [_c('v-img', {
      staticClass: "quest-library-icon",
      attrs: {
        "src": _vm.$asset.contentslogo.format(title.m_TitleType) + '.png',
        "contain": ""
      }
    })], 1), _c('v-list-item-content', {
      staticClass: "ml-0",
      style: {
        'max-width': '240px'
      }
    }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(title.m_DisplayName)))]), _vm.sort == 'rare' ? _c('v-list-item-subtitle', [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(_vm.count(title.m_TitleType, 4)))]), _c('span', [_vm._v(" + ")]), _c('span', [_vm._v(_vm._s(_vm.count(title.m_TitleType, 3)))]), _c('span', [_vm._v(" + ")]), _c('span', [_vm._v(_vm._s(_vm.count(title.m_TitleType, 2)))])]) : _vm._e(), _vm.sort == 'characters' ? _c('v-list-item-subtitle', [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(_vm.count(title.m_TitleType, 0)))]), _c('span', [_vm._v(" (")]), _c('span', [_vm._v(_vm._s(_vm.count(title.m_TitleType, 4)))]), _c('span', [_vm._v(" + ")]), _c('span', [_vm._v(_vm._s(_vm.count(title.m_TitleType, 3)))]), _c('span', [_vm._v(" + ")]), _c('span', [_vm._v(_vm._s(_vm.count(title.m_TitleType, 2)))]), _c('span', [_vm._v(") ")])]) : _vm._e()], 1), _c('div', {
      staticClass: "mr-auto"
    })], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }